import { Tooltip } from 'react-tooltip'
import cn from 'classnames'

const BadgeCell = ({
  code,
  areSame,
  onClick,
  classnames,
  tooltipText,
  onClickNotSame,
}) => {
  const handleOnClickOnAlert = e => {
    e.stopPropagation()
    onClickNotSame()
  }
  return (
    <div className="badge-container ">
      <div className={cn('badge', classnames)} onClick={onClick}>
        {code}
      </div>
      {!areSame && (
        <div className="warning-tipos-button" onClick={handleOnClickOnAlert}>
          <p className="warning-tipos-icon warning-tipos-icon--panel">!</p>
        </div>
      )}
      <Tooltip
        anchorSelect=".warning-tipos-button"
        style={{ zIndex: '99999999' }}
      >
        Hay diferencias con los elementos guardados en BD y la versión actual.
      </Tooltip>
      {tooltipText && (
        <Tooltip
          anchorSelect=".badge"
          style={{
            fontSize: '9px',
          }}
        >
          {tooltipText}
        </Tooltip>
      )}
    </div>
  )
}

export default BadgeCell
